/// <reference path="../../TypeLite.Net4.d.ts" />
import { ISelectableItem } from '../../components/selectableItem/selectableItemConverters';

export enum CountriesPageActionTypes {
	SHOW_CountriesPage = '@@countriesPage/SHOW',
	HIDE_CountriesPage = '@@countriesPage/HIDE'
}

// Declare state types with `readonly` modifier to get compile time immutability.
export interface CountriesPageState {
	readonly isVisible: boolean
}
